import { INTEGRATED_APP_HOME_PAGE_URL_PREFIX } from "utils/integration/constants";
import { useLocation } from "react-router-dom";
import * as storage from "utils/local-storage";
import { SPEED_ACCOUNT_ID, SPEED_LIGHTNING_ADDRESS } from "utils/constants";

export const useIsIntegratedAppHomePage = () => {
  const location = useLocation();
  return location.pathname.split("/").includes(INTEGRATED_APP_HOME_PAGE_URL_PREFIX);
};

/**
 * Read the Speed Mini App session values that were written to sessionStorage
 * at handshake (InitializeIntegrationApp, when `?acct=...` is in the URL).
 *
 * This mirrors how `integrated-app-http-client.ts` reads USER_ID/TOKEN — the
 * handshake happens once on iframe mount, values live in sessionStorage, and
 * every downstream caller reads from there directly rather than relying on
 * Redux being populated on the current screen.
 */
export const getSpeedSession = (): {
  accountId: string;
  lightningAddress: string;
} => ({
  accountId: storage.session.getItem(SPEED_ACCOUNT_ID) || "",
  lightningAddress: storage.session.getItem(SPEED_LIGHTNING_ADDRESS) || "",
});